module.exports = __webpack_public_path__ + "static/media/lock.f974125f.svg";